/* @matra/styles: a classless foundation for semantic Matra HTML. */
:root {
  color-scheme: light;
  --matra-ink: #16211b;
  --matra-muted: #667169;
  --matra-paper: #f7f6f0;
  --matra-surface: #ffffff;
  --matra-line: #d9ddd5;
  --matra-accent: #587000;
  --matra-link: #285d4a;
  --matra-radius: 0.75rem;
  font-family: ui-sans-serif, system-ui, sans-serif;
  color: var(--matra-ink);
  background: var(--matra-paper);
  line-height: 1.65;
}

* { box-sizing: border-box; }
body { max-width: 72rem; margin: 0 auto; padding: clamp(1.25rem, 5vw, 4rem); }
body > * + * { margin-top: 1.5rem; }
article, aside, details, figure, footer, form, header, main, nav, section { max-width: 100%; }
header > :first-child, main > :first-child, article > :first-child, section > :first-child { margin-top: 0; }
h1, h2, h3, h4, h5, h6 { margin: 2.5rem 0 0.8rem; color: var(--matra-ink); line-height: 1.15; letter-spacing: -0.025em; }
h1 { font-size: clamp(2.25rem, 7vw, 4.75rem); }
h2 { font-size: clamp(1.6rem, 4vw, 2.5rem); }
h3 { font-size: 1.25rem; }
p, ul, ol, dl, blockquote, pre, table, figure { margin: 0 0 1.25rem; }
p, li, dd { max-width: 72ch; }
ul, ol { padding-left: 1.45rem; }
ul { list-style-type: square; }
ol { list-style-type: decimal; }
li + li { margin-top: 0.4rem; }
li::marker { color: var(--matra-accent); font-weight: 700; }
dl { display: grid; grid-template-columns: minmax(7rem, auto) minmax(0, 1fr); gap: 0.55rem 1.25rem; }
dt { font-weight: 700; }
dd { margin: 0; color: var(--matra-muted); }
small, figcaption { color: var(--matra-muted); }
a { color: var(--matra-link); text-decoration-thickness: 0.08em; text-underline-offset: 0.16em; }
a:hover { color: var(--matra-accent); }
nav > ul { margin-top: 1rem; }
.matra-nav > ul { display: flex; flex-wrap: wrap; gap: 0.5rem 1.25rem; margin: 0; padding: 0; list-style: none; }
.matra-nav a { font-weight: 650; }
blockquote { margin-left: 0; padding: 1rem 1.25rem; border-left: 0.25rem solid var(--matra-accent); color: var(--matra-muted); background: color-mix(in srgb, var(--matra-surface) 78%, var(--matra-paper)); }
hr { height: 1px; margin: 2.5rem 0; border: 0; background: var(--matra-line); }
code, kbd, samp { padding: 0.12em 0.32em; border-radius: 0.25rem; background: #e9ece5; font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 0.9em; }
pre { overflow-x: auto; padding: 1rem 1.25rem; border-radius: var(--matra-radius); color: #eaf0eb; background: #16211b; }
pre code { padding: 0; color: inherit; background: transparent; }
table { width: 100%; border-collapse: collapse; }
th, td { padding: 0.7rem; border-bottom: 1px solid var(--matra-line); text-align: left; vertical-align: top; }
th { color: var(--matra-muted); font-size: 0.8rem; text-transform: uppercase; letter-spacing: 0.06em; }
img, video, svg { max-width: 100%; height: auto; }
button, input, select, textarea { font: inherit; }
button, input[type="submit"], input[type="button"] { padding: 0.55rem 0.9rem; border: 1px solid var(--matra-ink); border-radius: 0.45rem; color: white; background: var(--matra-ink); cursor: pointer; }
input, select, textarea { max-width: 100%; padding: 0.55rem 0.65rem; border: 1px solid var(--matra-line); border-radius: 0.45rem; color: inherit; background: var(--matra-surface); }
label { display: inline-grid; gap: 0.35rem; font-weight: 650; }
fieldset { margin: 0 0 1.25rem; border: 1px solid var(--matra-line); border-radius: var(--matra-radius); }
details { padding: 0.8rem 1rem; border: 1px solid var(--matra-line); border-radius: var(--matra-radius); background: var(--matra-surface); }
summary { cursor: pointer; font-weight: 700; }
.matra-callout { padding: 1rem 1.25rem; border: 1px solid var(--matra-line); border-radius: var(--matra-radius); background: var(--matra-surface); }
.matra-stack > * + * { margin-top: 1rem; }
.matra-cluster { display: flex; flex-wrap: wrap; gap: 0.75rem; align-items: center; }
.matra-frame { padding: clamp(1rem, 4vw, 2rem); border: 1px solid var(--matra-line); border-radius: var(--matra-radius); background: var(--matra-surface); }
.matra-button { display: inline-block; padding: 0.55rem 0.9rem; border-radius: 0.45rem; color: white; background: var(--matra-ink); font-weight: 700; text-decoration: none; }
.matra-button:hover { color: white; background: var(--matra-accent); }
